import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const siteRoutes = [
  {
    path: 'site/:currentSiteIdParam',
    component: () =>
      import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
        withWebsiteEditingMode(() => import('@/features/site/SiteRouterView.vue')),
      ),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.SitesView,
    },
    children: [
      {
        path: 'sitemap-builder',
        component: () =>
          import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
            withWebsiteEditingMode(() => import('@/features/siteMapBuilder/SiteMapBuilder.vue')),
          ),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SitesSitemapUpdate,
        },
      },
      {
        path: 'content-importer',
        component: () =>
          import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
            withWebsiteEditingMode(
              () => import('@/features/siteImport/views/SiteZipContentImporterPage.vue'),
            ),
          ),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SitesSitemapUpdate,
        },
      },
      {
        path: 'page-builder',
        component: () =>
          import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
            withWebsiteEditingMode(
              () => import('@/features/sitePageBuilder/SitePageBuilderLayout.vue'),
            ),
          ),
        meta: {
          hideLayoutHeader: true,
          layoutPadding: false,
          permissionAction: PermissionActions.SitesPagesUpdate,
        },
        children: [
          {
            path: ':pageId',
            component: () =>
              import('@/features/sitePageBuilder/SitePageBuilderContent.vue').then(m => m.default),
            meta: {
              hideLayoutHeader: true,
              layoutPadding: false,
              permissionAction: PermissionActions.SitesPagesUpdate,
            },
          },
        ],
      },
    ],
  },
  {
    path: 'site-new',
    component: () =>
      import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
        withWebsiteEditingMode(() => import('@/features/site/SiteNewPage.vue')),
      ),
    meta: { permissionAction: PermissionActions.SitesCreate },
  },
  {
    path: 'site-list',
    component: () =>
      import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
        withWebsiteEditingMode(() => import('@/features/site/SiteList.vue')),
      ),
    meta: { permissionAction: PermissionActions.SitesView },
  },
  {
    path: 'site-list-removed',
    component: () =>
      import('@/features/site/withTemplateEditingMode.js').then(({ withWebsiteEditingMode }) =>
        withWebsiteEditingMode(() => import('@/features/site/SiteList.vue')),
      ),
    props: { isRemovedList: true },
    meta: { permissionAction: PermissionActions.SitesView },
  },
]
